<template>
    <div></div>
</template>

<script>
  export default {
    name: 'CommCss'
  }
</script>

<style lang="scss">
    .weditor {
        /* editor-common.css：编辑器和展示页共用 */
        div, p, h1, h2, h3, ul, ol {
            color:var(--font);
            line-height:1.5;
            margin:0;
            padding:0;
            font-size: 1rem;
            font-weight: 350;
        }
        ul, ol {
            padding-left:15px;
            list-style-position:outside;
        }
        ul { list-style-type:disc; }
        ol { list-style-type:decimal; }
        li { margin:5px 0;}

        div {margin:5px 0;}
        p { margin: 15px 0; }
        h1 { margin: 20px 0;font-size:2em; }
        h2 { margin: 20px 0;font-size:1.5em; }
        h3 { margin: 20px 0;font-size:1.17em; }
        h4 { margin: 20px 0; }
        h5 { margin: 20px 0; }

        a { color: #0066cc; text-decoration: none; }
        a:hover { text-decoration: underline; }
        strong { font-weight: 700; }
        em { font-style: italic; }

        img {
        max-width: 100% !important;
        }
    }
    .btn {
        display: inline-block;
        color: #fff;
        font-size: 1.2rem;
        font-weight: 350;
        text-align: center;
        &.medium {
            padding: 1rem 2rem;
        }
        &.caise {
            background: linear-gradient(0deg, #8831be, #3946cc);
        }
        &.yuanjiao {
            border-radius: 2rem;
        }
    }
    .page-pagination {
        display: flex;
        padding: 2rem 0;
        justify-content: center;
        align-items: center;
        gap:0.5rem;
        clear: both;
        .page-btn, .page-number {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 2.6rem;
            height: 2.6rem;
            font-size: 1rem;
            border: 1px solid #ddd;
            background: white;
            box-sizing: border-box;
            border-radius: 4px;
            cursor: pointer;
            &:hover {
                background: #f0f0f0;
            }
            &[disabled] {
                opacity: 0.5;
                cursor: not-allowed;
            }
        }
        .page-btn {
            width: 5rem;
        }
        .page-number {
            text-align: center;
            &.active {
                color: white;
                border-color: var(--main);
                background-color: var(--main);
            }
        }
    }
    .partnews {
        width: 100%;
        .news-link {
            display: block;
            text-decoration: none;
            background-color: #fafafa;
            border-radius: 0.6rem;
            overflow: hidden;
            transition: all 0.3s ease;
            transform: translateY(0);
        }
        .itemw {
            position: relative;
        }
        .pics {
            position: relative;
            width: 100%;
            aspect-ratio: 3 / 1.8; 
            overflow: hidden;
        }
        .pics img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.5s ease;
        }
        .news-link:hover .pics img {
            transform: scale(1.1);
        }
        .image-overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, transparent 100%);
            opacity: 0.3;
            transition: opacity 0.3s ease;
        }
        .news-link:hover .image-overlay {
            opacity: 0.5;
        }
        .items {
            position: relative;
            display: flex;
            padding: 1.2rem;
            flex-direction: column;
            justify-content: space-between;
        }
        .tips {
            color: var(--main);
            font-size: 1.15rem;
            font-weight: 550;
            margin-bottom: 1rem;
            line-height: 1.4;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            min-height: calc(1.15rem * 1.4 * 2); 
            height: calc(1.15rem * 1.4 * 2);
        }
        .smys {
            color: var(--fontgray);
            font-size: 0.95rem;
            line-height: 1.5;
            margin-bottom: 1.5rem;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            word-break: break-word;
            max-height: calc(1.5rem * 3);
        }
        .time {
            color: var(--fontgray);
            font-size: 0.9rem;
            font-weight: 400;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
        .time::before {
            content: "•";
            font-size: 1.2rem;
            color: #4299e1;
        }
    }
    #pg-content {
        display:inline-block;
        width: 100%;
    }
    .cm-head1 {
        display: block;
        margin-bottom: 2.5rem;
    }
    .cm-imgcon {
        text-align: center;
        img {
            max-width:60%;
        }
    }
    .cm-title {
        position: relative;
        display: block;
        .title_up {
            position: relative;
            display: flex;
            align-items: center;
            font-size: 1rem;
            font-weight: 350;
            z-index:5;
            gap:0.5rem;
            img {
                height: 1.0rem;
            }
        }
        .title_main {
            position: relative;
            margin-bottom: 1rem;
            z-index:3;
            .font {
                position: relative;
                font-size: 2.4rem;
                font-weight: 600;
                z-index: 1;
            }
            b {
                color: #ffffff;
                position: absolute;
                top: -35%;
                left: 0;
                width: 100%;
                font-size: 4rem;
                font-weight: 700;
                text-transform: uppercase;
                z-index: 0;
            }
        }
        .title_smy {
            color: var(--fontgray);
            font-size: 1.05rem;
            font-weight: 400;
            line-height: 1.5;
        }
        &.center {
            text-align: center;
            .title_up {
                justify-content: center;
            }
        }
        &.dark {
            .title_up {
                color: var(--fontred);
            }
            .title_main {
                .font {
                    color: var(--main);
                }
            }
            b {
                color: var(--fonttip);
            }
        }
        &.white {
            .title_up {
                color: #ffffff;
                text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
                img {
                    opacity: 0.8;
                    filter: invert(1);
                }
            }
            .title_main {
                .font {
                    color: #ffffff;
                    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
                }
                b {
                    color:rgba(255,255,255,0.1);
                }
            }
            .title_smy {
                color: rgba(255,255,255,0.8);
            }
        }
    }
    .detail-ul li {
        display: inline-flex;
        width: 100%;
        margin: 0.2rem 0;
        align-items: center;
        justify-content: start;
        gap:0.5rem;
    }
    .solutions_list {
        li {
            color: #ffffff;
            display: flex;
            width: 100%;
            padding:0.3rem 0;
            gap: 0.6rem;
            &::before {
                content: "\e7d3";
                font-family: "iconfont" !important;
                font-size: 1.4rem; 
                color: #52c41a;
                flex-shrink: 0;
                margin-top: -0.2rem;
            }
        }
    }
    .os-items {
        .service-detail {
            li {
                display: flex;
                margin:0.2rem 0;
                align-items: center;
                justify-content: start;
                gap:0.5rem;
                font-size: 1rem;
                img {
                    border:1px solid rgba(255,255,255,0.8);
                    background-color: #ffffff;
                    border-radius:50%;
                }
            }
        }
        &:nth-child(2n) {
            .service-detail li {
                justify-content: end;
                flex-direction: row-reverse;
            }
        }
    }
    /* swiper 覆盖 */
    .swiper-container {
        width: 100%;
    }
    .swiper {
        position: relative;
        padding:0 0 3rem 0 !important;
    }
    .swiper-button-prev , .swiper-button-next {
        width: 3rem !important;
        height: 3rem !important;
        margin-top:-3rem !important;
        background-color: rgba(0, 0, 0, 0.3);
        border-radius: 50%;
        .swiper-navigation-icon {
            color: #fff;
            width: 1.6rem !important;
            height: 1.6rem !important;
        }
    }
    .swiper-button-prev {
        .swiper-navigation-icon {
            transform:rotate(180deg) !important;
        }
    }
    .swiper-wrapper {
        position: relative;
    }
    .swiper-pagination-bullet-active {
        width: 1.5rem !important;
        border-radius: 4px !important;
    }
    .swiper-items {
        display: block;
        overflow: hidden;
        transition: all 0.3s ease;
        border-radius: 0.6rem;
    }
    .swiper-card {
        overflow: hidden;
        display: flex;
        flex-direction: column;
        height: 100%;
        border-radius: 0.3rem;
    }
    @media (min-width: 0px) and (max-width: 1279px) {

    }
    @media (min-width: 0px) and (max-width: 1279px) {
        #wn-fixed {
            display: none;
        }
        h1 {
            font-size: 1.5rem;
        }
        .cm-head1 {
            margin-bottom: 1rem;
        }
        .leftmargin {
            margin-right: 0 !important;
        }
        .rightmargin {
            margin-left: 0;
        }
        .cm-title {
            .title_up {
                margin-bottom: 0.5rem;
            }
            .title_main {
                .font {
                    font-size: 1.55rem;
                    font-weight: 540;
                }
                b {
                    display: none;
                }
            }
            .title_smy {
                font-size: 0.9rem;
            }
        }
        .weditor {
            div, p, h1, h2, h3, ul, ol {
                line-height:1.4;
            }
         }
        .os-items {
            &:nth-child(2n) {
                .service-detail li {
                    justify-content: start;
                    flex-direction: row;
                }
            }
        }
        .partnews {
            .tips {
                min-height: calc(1.1rem * 1.4 * 2); 
                height: calc(1.1rem * 1.4 * 2);
                font-size: 1.1rem;
                font-weight: 400;
            }
            .smys {
                font-size: 0.9rem;
            }
        }
        .btn {
            font-size: 1rem;
            &.medium {
                padding: 0.8rem 1.6rem;
            }
        }
    }
    @media (min-width: 0px) and (max-width: 639px) {
        .swiper-pagination {
            span {
                margin:0 2px !important;
            }
        }
    }
</style>